import React from 'react';
import Navbar from '../components/navBar';
import Hero from '../components/hero';
import Services from '../components/services';
import Footer from '../components/footer';
import Steps from '../components/steps';
import Testimonials from '../components/testimonials';
import AppointmentForm from '../components/appointment';
import AppointmentAndAppDownload from '../components/appointmentSchedule';
import FAQ from '../components/faqs';

function Home() {
  return (
    <div className="bg-light min-h-screen">
      {/* <Navbar /> */}
      <Hero />
      <Services />
      <Steps />
      <AppointmentAndAppDownload />
      {/* <AppointmentForm /> */}
      <Testimonials />
      <FAQ />
      {/* <Footer /> */}
    </div>
  );
}

export default Home;